import { Button, Col, DatePicker, Form, Input, Row } from 'antd';
import { useSelector } from 'react-redux';

export const transactionTypes = [
  { value: 1, label: 'Submitted' },
  { value: 2, label: 'Marked' },
  { value: 1, label: 'Not Submitted' },
];

const FilterAssessmentForm = ({ filterForm, onFinish }) => {
  const userType = useSelector(
    (state: any) => state?.auth?.creds?.user_data?.user_type
  );

  const loading = useSelector(
    (state: any) => state?.allAssessmentReducer?.assessment?.getAssessmentStatus
  );

  return (
    <Form form={filterForm} onFinish={onFinish}>
      <Row>
        <Col span={6} className="mr-2">
          <Form.Item
            label="Assessment Name"
            name={userType === 'client' ? 'question' : 'title'}
            className="mb-2 "
          >
            <Input name="name" id="name" placeholder="Assessment Name" type="text" />
          </Form.Item>
        </Col>
        <Col span={6} className="mr-2">
          <Form.Item label="Room Name" name="room" className="mb-2 ">
            <Input placeholder="Room Name" type="text" />
          </Form.Item>
        </Col>
        <Col span={6} className="mr-2">
          <Form.Item label="Course Name" name="course" className="mb-2 ">
            <Input placeholder="Course Name" type="text" />
          </Form.Item>
        </Col>
        <Col span={6} className="mr-2">
          <Form.Item label="Due Date" name="due_date" className="mb-2 ">
            <DatePicker
              format={'YYYY-MM-DD'}
              picker="date"
              className="w-100"
              getPopupContainer={(triggerNode: HTMLElement) =>
                triggerNode.parentNode as HTMLElement
              }
            />
          </Form.Item>
        </Col>

        <div className="d-flex justify-content-end" style={{ marginTop: '2.5rem' }}>
          <Button
            type="primary"
            htmlType="submit"
            className="ml-1"
            loading={loading === 'request'}
          >
            Filter
          </Button>
        </div>
      </Row>
    </Form>
  );
};

export default FilterAssessmentForm;
